import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useState } from 'react'
import Modal from './Modal'

interface Props {
  videoId: string
}

const VideoGuide: FC<Props> = (props) => {
  const {
    videoId,
  } = props

  const [isOpenVideo, setIsOpenVideo] = useState<boolean>(false)

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (isOpenVideo) {
      html.classList.add('modal_open')
    } else {
      html.classList.remove('modal_open')
    }
  }, [isOpenVideo])

  return (
    <>
      <div>
        <div
          className="icon"
          onClick={() => setIsOpenVideo(true)}
          role="none"
        >
          <FontAwesomeIcon
            icon={['fas', 'film']}
          />
        </div>
        <div
          style={{
            fontSize: "8px",
            textAlign: "center",
            marginTop: "2px",
          }}
        >
          ガイド
        </div>
      </div>
      <Modal
        modalSize="large"
        show={isOpenVideo}
        closeCallback={() => setIsOpenVideo(false)}
        closeable
      >
        <>
          <iframe
            width="836"
            height="470"
            src={`https://www.youtube.com/embed/${videoId}?cc_load_policy=1`}
            title="YouTube video player"
            frameBorder="0"
            allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </>
      </Modal>
    </>
  )
}

export default VideoGuide
